import React from 'react';
import styled from 'styled-components';
import { HeaderTitle } from '../../../utils/budget-tool-specific';
import FlightsExperimentalList from './flights-experimental-list';

const FlightsExperimental = (props) => {
    return (
        <PageContainer>
            <HeaderTitle>
                Flights (exp.) 🚀
            </HeaderTitle>
            <div style={{
                backgroundColor: "#e7f3ff",
                border: "1px solid #b3d9ff",
                borderRadius: "8px",
                padding: "15px",
                margin: "15px",
                marginBottom: "30px"
            }}>
                <p style={{margin: "0", fontSize: "14px", color: "#0056b3"}}>
                    <strong>🧪 Experimental Feature:</strong> This version allows you to switch between FlightApi.io and Amadeus APIs.
                    Your existing flight guides remain untouched in the main Flights section.
                </p>
            </div>
            <FlightsExperimentalList/>
        </PageContainer>
    )
}

export default FlightsExperimental;

const PageContainer = styled.div`
    padding: 30px 15px;
    height: 100%;
    box-sizing: border-box;
`;